import { render } from "./PrivacyProtectionPolicy.vue?vue&type=template&id=18900e1c"
const script = {}

import "./PrivacyProtectionPolicy.vue?vue&type=style&index=0&id=18900e1c&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1501305b0fb1954c01d0b4f35a9e823f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__